import { state } from "../state/workspaceStore.js";
import { head } from "../components/common/PageHeader.jsx";
import {
  field,
  select,
  check,
  errorSlot,
} from "../components/forms/FormControls.jsx";
import { tableViews } from "../components/tables/RecordTable.jsx";
export function settings() {
  let s = state.db.settings;
  return (
    <>
      {head(
        "CONFIGURATION",
        "Content / Settings",
        "Business, support and shipping settings.",
        <button className={"btn"} type={"submit"} form={"settings-form"}>
          {"Save Changes"}
        </button>,
      )}
      {
        <form id={"settings-form"} className={"stack settings-simple"}>
          <section className={"card"}>
            <h2>{"Business & support"}</h2>
            <div className={"form-grid"}>
              {field(
                "Legal entity *",
                "legalEntity",
                s.legalEntity,
                "text",
                "required",
              )}
              {field("Brand *", "brand", s.brand, "text", "required")}
              {field(
                "Business email *",
                "businessEmail",
                s.businessEmail,
                "email",
                "required",
              )}
              {field(
                "Business contact *",
                "businessPhone",
                s.businessPhone,
                "tel",
                "required",
              )}
              {field(
                "Support email *",
                "supportEmail",
                s.supportEmail,
                "email",
                "required",
              )}
              {field(
                "Support phone *",
                "supportPhone",
                s.supportPhone,
                "tel",
                "required",
              )}
            </div>
            {field(
              "Business / dispatch address *",
              "address",
              s.address,
              "text",
              "required",
            )}
          </section>
          <section className={"card"}>
            <h2>{"Pricing & shipping"}</h2>
            <div className={"form-grid"}>
              {select("Currency", "currency", s.currency, ["INR"])}
              {field(
                "Minimum merchandise value ₹",
                "minimumOrder",
                s.minimumOrder,
                "number",
                'min="0" step="0.01" required',
              )}
              {field(
                "Standard shipping ₹",
                "shippingFee",
                s.shippingFee,
                "number",
                'min="0" step="0.01" required',
              )}
              {field(
                "Free shipping strictly above ₹",
                "freeThreshold",
                s.freeThreshold,
                "number",
                'min="0" step="0.01" required',
              )}
              {select("Coverage", "coverage", s.coverage, ["India"])}
              {field(
                "Dispatch estimate",
                "dispatchEstimate",
                s.dispatchEstimate,
              )}
            </div>
            {check("Prices include GST", "gstInclusive", s.gstInclusive)}
            {check("COD enabled", "cod", s.cod)}
            {check(
              "Partial shipments enabled",
              "partialShipments",
              s.partialShipments,
            )}
            {check(
              "Weekend / holiday processing",
              "weekendProcessing",
              s.weekendProcessing,
            )}
            <p className={"hint"}>
              {
                "The local order workflow remains prepaid and uses whole-order fulfilment. Shipping uses merchandise value before discount; the free threshold is exclusive."
              }
            </p>
          </section>
          {errorSlot()}
        </form>
      }
    </>
  );
}
export default function SettingsPage({ recordId } = {}) {
  return tableViews(settings());
}
